import { createFileRoute } from '@tanstack/react-router';
import { CustomClerkForgotPasswordForm } from '../components/auth/CustomClerkForgotPasswordForm';
import { LoginPageLayout } from '../components/auth/LoginPageLayout';

export const Route = createFileRoute('/forgot-password')({
  component: ForgotPasswordRouteComponent,
});

function ForgotPasswordRouteComponent() {
  return (
    <LoginPageLayout>
      <CustomClerkForgotPasswordForm signInHref="/login" afterResetRedirect="/client" />
    </LoginPageLayout>
  );
}
